module.exports = __webpack_public_path__ + "1b5355c2813fe13273af64b8987ce914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/promo/ts_rs6.jpg
// module id = 1042
// module chunks = 0